import { render } from "./Agenda.vue?vue&type=template&id=1c5a0c27"
import script from "./Agenda.vue?vue&type=script&lang=js"
export * from "./Agenda.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__